// @ts-check
import langs from 'iso-language-codes';

/** @type {{[lang: string]: string}} */
// Handle odd one-off language pairs that might show up over time
const specialLangs =  {
  "zh-hans": "中文 (Zhōngwén)",
};

/**
 * @typedef {string} ISO6391
 * Language code in ISO 639-1 format. e.g. en, fr, zh
 **/

/**
 * @param {string} language in some format
 * @return {ISO6391?}
 */
export function toISO6391(language) {
  if (!language) return null;
  language = language.toLocaleLowerCase();
  if (specialLangs[language]) {
    return language;
  }
  const codeObj = (
    findLanguage(language, ['iso639_1']) ||
    findLanguage(language, ['iso639_2T']) ||
    findLanguage(language, ['iso639_2B', 'name', 'nativeName'])
  );
  if (codeObj) return codeObj.iso639_1;
  return null;
}

/**
 *
 * @param {string} language
 * @returns {string | null}
 */
export function toNativeName(language) {
  if (!language) return null;
  language = language.toLocaleLowerCase();
  if (specialLangs[language]) {
    return specialLangs[language];
  }
  const codeObj = (
    findLanguage(language, ['iso639_1']) ||
    findLanguage(language, ['iso639_2T']) ||
    findLanguage(language, ['iso639_2B', 'name', 'nativeName'])
  );
  if (codeObj?.nativeName) return codeObj.nativeName.split(", ")[0];
  return null;
}

/** @typedef {import('iso-language-codes').Code} Code */

/**
 * @param {string} language
 * @param {Array<'iso639_1' | 'iso639_2T' | 'iso639_2B' | 'nativeName' | 'name'>} fields
 * @returns {Code | null}
 */
function findLanguage(language, fields) {
  if (!language) return null;
  language = language.toLowerCase();
  for (const lang of langs) {
    for (const codeType of fields) {
      if (lang[codeType]?.toLowerCase().split(", ").includes(language)) {
        return lang;
      }
    }
  }
  return null;
}

/**
 * Checks whether the current browser supports localStorage or
 * if the current context has access to it.
 * @return {boolean}
 */
export function hasLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    // Will throw in sandboxed iframe
    // DOMException: Window.localStorage getter: Forbidden in a sandboxed document without the 'allow-same-origin' flag.
    return false;
  }
}

export const DEBUG_READ_ALOUD = location.toString().indexOf('_debugReadAloud=true') != -1;

export async function checkIfFiresPause() {
  // Pick some random text so that if it accidentally speaks, it's not too annoying
  const u = new SpeechSynthesisUtterance("Loading");
  let calledPause = false;
  u.addEventListener('pause', () => calledPause = true);
  speechSynthesis.speak(u);
  await new Promise(res => setTimeout(res, 10));
  speechSynthesis.pause();
  return calledPause;
}
